export const LIST_SETTLE_MS = 220;
export const LIST_SETTLE_EASING = 'cubic-bezier(.3,1.25,.45,1)';
export const CLUSTER_ITEM_MS = 180;
export const CLUSTER_STAGGER_MS = 20;
export const TAB_CROSSFADE_MS = 200;

export function prefersReducedMotion() {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function listWidthTransitionClass({ dragging, reducedMotion } = {}) {
  if (dragging || reducedMotion === true) return 'transition-none';
  if (reducedMotion !== false && prefersReducedMotion())
    return 'transition-none';
  return `transition-[width] duration-[${LIST_SETTLE_MS}ms] ease-[${LIST_SETTLE_EASING}] motion-reduce:transition-none`;
}

export function listWidthTransitionStyle({ dragging, reducedMotion } = {}) {
  if (
    dragging ||
    reducedMotion === true ||
    (reducedMotion !== false && prefersReducedMotion())
  ) {
    return undefined;
  }
  return {
    transitionProperty: 'width',
    transitionDuration: `${LIST_SETTLE_MS}ms`,
    transitionTimingFunction: LIST_SETTLE_EASING,
  };
}

export function clusterItemDelayMs(index, { reducedMotion } = {}) {
  if (reducedMotion === true) return 0;
  if (reducedMotion !== false && prefersReducedMotion()) return 0;
  return index * CLUSTER_STAGGER_MS;
}
